import createElement from '@javascripts/utils/create_element';
import LocationAdapter from '@javascripts/adapters/location_adapter';
import { PlayerAhoyEvent } from '../../player_ahoy_event';

export default class Episode {
  constructor({ episode, isCurrentEpisode, data } = {}) {
    this._episode = episode;
    this._isCurrentEpisode = isCurrentEpisode;
    this._data = data;
  }

  episode() {
    return this._episode;
  }

  isCurrentEpisode() {
    return this._isCurrentEpisode;
  }

  data() {
    return this._data;
  }

  dom() {
    const episode = this.createListItem();
    const button = this.createButton(this.episode().url);

    episode.append(button);

    if (this.isCurrentEpisode() === true) {
      episode.classList.add('current');
    }

    return episode;
  }

  createListItem() {
    return createElement(`<li class="episode-chooser-episode-list-item"></li>`);
  }

  createEpisode() {
    return createElement(`
      <figure class="episode-chooser-figure">
        <div>
          <img src="${this.episode().thumbnail}" />
        </div>
        <figcaption>${this.episode().description}</figcaption>
      </figure>
    `);
  }

  createButton(url) {
    const button = createElement(`
      <button class="episode-chooser-episode-list-button">
        <span>${this.episode().title}</span>
      </button>
    `);
    button.appendChild(this.createEpisode());
    button.onclick = () => {
      this.onClick(url);
    };

    return button;
  }

  onClick(url) {
    this.sendEvent({ next_url: url, action: 'click' });
    LocationAdapter.href(url);
  }

  sendEvent({ next_url, action }) {
    PlayerAhoyEvent.sendEpisodeList({
      play_uuid: this.data().playUUID(),
      current_video_id: this.data().videoId(),
      next_video_id: next_url === null ? null : this.getVideoIdFromUrl(next_url),
      action: action
    });
  }

  getVideoIdFromUrl(url) {
    return url.split('/watch/')[1].split('-')[0];
  }
}
